import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Content, Sider } = Layout;

const graphs = [
  {
    id: "graph1",
    title: "Evolución en el tiempo",
    menuTitle: "Evolución en el tiempo",
    text: `En Chile 1 de cada 10 niñas y niños vive en hogares que declaran tener al menos dos problemas de contaminación en su entorno cercano. Entre 2017 
          y 2022 este problema disminuyó significativamente.`,
    link: "https://public.flourish.studio/visualisation/25083187/embed",
  },
  {
    id: "graph2",
    title: "Análisis por edad",
    menuTitle: "\u2022 Edad",
    text: `Entre 2015 y 2022, en todos los tramos etarios disminuyó la cantidad de niñas y niños que viven en hogares que declaran estar expuestos a al menos 
          2 tipos de  contaminación (acústica, del aire, agua y  basura en calles).`,
    link: "https://public.flourish.studio/visualisation/25083640/embed",
  },
  {
    id: "graph3",
    title: "Análisis por país de nacimiento",
    menuTitle: "\u2022 País de nacimiento",
    text: `Un 11% de niñas y niños que nacieron fuera de Chile viven en hogares que declaran estar expuestos a contaminación. Esta cifra es levemente mayor a 
          la observada para niñas y niños nacidos en Chile. Sin embargo, esta diferencia no es estadísticamente significativa. Entre 2017 y 2022, la 
          proporción de niñas y niños que viven en barrios contaminados sólo disminuyó para las y los que nacieron en el país, entre las y los que nacieron 
          fuera se mantuvo constante.`,
    link: "https://public.flourish.studio/visualisation/25083768/embed",
  },
  {
    id: "graph5",
    title: "Análisis por pueblo originario",
    menuTitle: "\u2022 Pueblo originario",
    text: `No se observaron diferencias estadísticamente significativas entre niñas y niños que se autoidentifican con pueblos originarios y quienes no para 
          ningún año de medición.`,
    link: "https://public.flourish.studio/visualisation/25083837/embed",
  },
  {
    id: "graph6",
    title: "Análisis por zona de residencia",
    menuTitle: "\u2022 Zona",
    text: `Un 10% de las niñas y los niños que viven en zonas urbanas está expuesto a contaminación en sus entornos, mientras que este porcentaje disminuye a 
          7% en zonas rurales. Solo entre las niñas y niños que residen en zonas urbanas ha habido una disminución significativa en la exposición a al menos 
          dos problemas de contaminación.`,
    link: "https://public.flourish.studio/visualisation/25084298/embed",
  },
  {
    id: "graph7",
    title: "Análisis por quintil de ingreso",
    menuTitle: "\u2022 Quintil de ingreso",
    text: `En 2022, entre el primer quintil, es decir, el de menores ingresos, y el cuarto quintil no hay diferencias estadísticamente significativas en la 
          proporción de niñas y niños expuestos a al menos dos problemas de contaminación. Sin embargo, el quintil de mayores ingresos presenta un porcentaje 
          menor (8%). Se ha documentado que niñas y niños que viven en hogares con carencias económicas son más propensos a vivir en barrios contaminados. [5]`,
    link: "https://public.flourish.studio/visualisation/25084184/embed",
  },
  {
    id: "graph8",
    title: "Análisis por macrozona",
    menuTitle: "\u2022 Macrozona",
    text: `Hay diferencias en la exposición a la contaminación según la macrozona en que residen niñas y niños. Por un lado, en 2022 la macrozona sur es la 
          que presenta una menor proporción de niñas y niños con al menos dos fuentes de contaminación cerca de sus hogares (9%). Por otro lado, la región 
          Metropolitana es la que tiene una proporción mayor (19%).`,
    link: "https://public.flourish.studio/visualisation/25084248/embed",
  },
  {
    id: "graph9",
    title: "Análisis por región",
    menuTitle: "\u2022 Región",
    text: `Las regiones que tienen una menor proporción de niñas y niños expuestos a al menos dos problemas de contaminación son las del sur del país. De esta 
          forma, Magallanes y Los Ríos son las regiones menos contaminadas. Las regiones, por el otro lado, que tienen una mayor proporción de niñas y niños 
          viviendo en barrios contaminados son Atacama, con un 24%, y la Metropolitana, con un 19%.`,
    link: "https://public.flourish.studio/visualisation/25083978/embed",
  },
];

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{ color: 'black', paddingLeft: graph.id !== "graph1" ? "30px" : "20px" }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div style={{ textAlign: 'justify' }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {selectedGraph.text}
                </ReactMarkdown>
              </div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
